module.exports = __webpack_public_path__ + "img/2019qinglongxia-3.98b06925.jpg";